import type { SalvarSimplesApuracaoDto, SimplesApuracaoListaResponse, SimplesApuracaoResponse } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/** GET /empresa/simples-apuracao: RBT12 e folha por competencia (digitados) e a apuracao vigente. */
export function useSimplesApuracao() {
  return useConsulta<SimplesApuracaoListaResponse>(['simples-apuracao'], '/empresa/simples-apuracao');
}

/** PUT /empresa/simples-apuracao/:competencia (upsert). `competencia` = YYYY-MM; valores em texto decimal. */
export function useSalvarSimplesApuracao() {
  return useMutacao<SimplesApuracaoResponse, { competencia: string; corpo: SalvarSimplesApuracaoDto }>({
    metodo: 'PUT',
    caminho: (v) => `/empresa/simples-apuracao/${v.competencia}`,
    corpo: (v) => v.corpo,
    invalidar: [['simples-apuracao']],
  });
}
